export default __webpack_public_path__ + "static/tobias_grober-avatar-aff08933b134cddf9d42c2542c471878.png";